<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Avenant</h1>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 form-request-content-large">
                        <div class="required-field-text">Champs obligatoires</div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <form
                                            name="exemption"
                                            method="post"
                                            enctype="multipart/form-data"
                                            novalidate="novalidate"
                                            class="needs-validation"
                                    >

                                        <!-- Insurer name -->
                                        <div class="form-group">
                                            <label for="insurer-name"
                                                   class="required-field-asterisks"
                                            >Nom d'organisme assureur</label>
                                            <input type="text"
                                                   id="insurer-name"
                                                   class="form-control form-control-lg"
                                                   :class="{ 'is-invalid': $v.formData.insurerName.$error }"
                                                   @input="delayTouch($v.formData.insurerName)"
                                                   v-model="formData.insurerName"
                                            >
                                            <FormError v-if="$v.formData.insurerName.$error"
                                                       error="Veuillez saisir le nom d'organisme assureur"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.insurerName.legalAdvice }}</p>
                                        </div>
                                        <!-- Insurer name -->

                                        <!-- Contract number -->
                                        <div class="form-group">
                                            <label for="contract-number"
                                                   class="required-field-asterisks"
                                            >N° du contrat</label>
                                            <input type="text"
                                                   id="contract-number"
                                                   class="form-control form-control-lg"
                                                   :class="{ 'is-invalid': $v.formData.contractNumber.$error }"
                                                   @input="delayTouch($v.formData.contractNumber)"
                                                   v-model="formData.contractNumber"
                                            >
                                            <FormError v-if="$v.formData.contractNumber.$error"
                                                       error="Veuillez saisir le numéro du contrat"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.contractNumber.legalAdvice }}</p>
                                        </div>
                                        <!-- Contract number -->

                                        <!-- Products and options -->
                                        <div class="form-group">
                                            <label for="products-and-options"
                                                   class="required-field-asterisks"
                                            >Produits et options choisis</label>
                                            <input type="text"
                                                   id="products-and-options"
                                                   class="form-control form-control-lg"
                                                   :class="{ 'is-invalid': $v.formData.productsAndOptionsChosen.$error }"
                                                   @input="delayTouch($v.formData.productsAndOptionsChosen)"
                                                   v-model="formData.productsAndOptionsChosen"
                                            >
                                            <FormError v-if="$v.formData.productsAndOptionsChosen.$error"
                                                       error="Veuillez saisir le nom de l'option de garantie choisie"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.productsAndOptionsChosen.legalAdvice }}</p>
                                        </div>
                                        <!-- Products and options  -->

                                        <!-- Contract start date -->
                                        <div class="form-group">
                                            <label for="contract-start-date"
                                                   class="required-field-asterisks"
                                            >Date de prise d'effet du contrat</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i class="far fa-calendar-alt"></i>
                                                    </span>
                                                </div>
                                                <masked-input type="text"
                                                              id="contract-start-date"
                                                              mask="11/11/1111"
                                                              class="form-control float-right"
                                                              :class="{ 'is-invalid': $v.formData.contractStartDate.$error }"
                                                              @input="maskedDelayTouch($v.formData.contractStartDate)"
                                                              v-model="formData.contractStartDate"
                                                />
                                            </div>
                                            <FormError error="Format de date incorrect"
                                                       v-if="!$v.formData.contractStartDate.validDate && $v.formData.contractStartDate.$dirty"
                                            ></FormError>
                                            <FormError error="Veuillez renseigner la date "
                                                       v-if="!$v.formData.contractStartDate.required && $v.formData.contractStartDate.$dirty"
                                            ></FormError>
                                            <FormError error="L'année indiquée n'est pas correcte"
                                                       v-if="!$v.formData.contractStartDate.isValidDateYear && $v.formData.contractStartDate.$dirty"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.contractStartDate.legalAdvice }}</p>
                                        </div>
                                        <!-- Contract start date -->

                                        <!-- Table of benefits -->
                                        <div class="contract-input-group mt-4">
                                            <label for="table-of-benefits"
                                                   class="required-field-asterisks"
                                            >Les conditions particulières</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.particularConditions">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="table-of-benefits"
                                                           @change="addDocument($event, 'particularConditions')"
                                                    >
                                                </span>
                                                <a v-if="formData.particularConditions"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('particularConditions')"
                                                >{{ formData.particularConditions.name }}</a>
                                                <a v-if="formData.particularConditions"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('particularConditions')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.particularConditions.validFileSize
                                                                 && !$v.formData.particularConditions.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 4MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.particularConditions.validMimeType
                                                                 && !$v.formData.particularConditions.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.particularConditions.legalAdvice }}</p>

                                        <!-- Table of benefits -->

                                        <!-- Copy of information note -->
                                        <div class="contract-input-group">
                                            <label for="copy-of-information-note"
                                                   class="required-field-asterisks"
                                            >Copie de la notice d’information</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.copyOfInformationNote">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="copy-of-information-note"
                                                           @change="addDocument($event, 'copyOfInformationNote')"
                                                    >
                                                </span>
                                                <a v-if="formData.copyOfInformationNote"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('copyOfInformationNote')"
                                                >{{ formData.copyOfInformationNote.name }}</a>
                                                <a v-if="formData.copyOfInformationNote"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('copyOfInformationNote')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.copyOfInformationNote.validFileSize
                                                                 && !$v.formData.copyOfInformationNote.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 4MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.copyOfInformationNote.validMimeType
                                                                 && !$v.formData.copyOfInformationNote.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <p v-if="legalInformation"
                                           class="input-legend"
                                        >{{ legalInformation.copyOfInformationNote.legalAdvice }}</p>
                                        <!-- Copy of information note -->

                                        <!-- Is optional contract available -->
                                        <div class="form-group">
                                            <label class="required-field-asterisks"
                                                   for="is-optional-contract-available"
                                            >Parallèlement au contrat à adhésion obligatoire, proposez
                                              vous à vos salariés l'adhésion à un contrat à adhésion
                                              facultative ?</label>
                                            <select id="is-optional-contract-available"
                                                    class="form-control select2"
                                                    v-model="formData.isOptionalContractAvailable"
                                            >
                                                <option :value="true">Oui</option>
                                                <option :value="false">Non</option>
                                            </select>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.isOptionalContractAvailable.legalAdvice }}</p>
                                        </div>
                                        <!-- Is optional contract available -->

                                        <!-- Optional contract number -->
                                        <div class="form-group" v-if="formData.isOptionalContractAvailable">
                                            <label for="optional-contract-number"
                                                   class="required-field-asterisks"
                                            >N° du contrat facultatif</label>
                                            <input type="text"
                                                   id="optional-contract-number"
                                                   class="form-control form-control-lg"
                                                   placeholder="N° du contrat (facultatif)"
                                                   :class="{ 'is-invalid': $v.formData.optionalContractNumber.$error }"
                                                   @input="delayTouch($v.formData.optionalContractNumber)"
                                                   v-model="formData.optionalContractNumber"
                                            >
                                            <FormError v-if="$v.formData.optionalContractNumber.$error"
                                                       error="Veuillez saisir le numéro du contrat facultatif"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.optionalContractNumber.legalAdvice }}</p>
                                        </div>
                                        <!-- Optional contract number -->

                                        <!-- Table of benefits facultative -->
                                        <div class="contract-input-group"
                                             v-if="formData.isOptionalContractAvailable"
                                        >
                                            <label for="table-of-benefits-facultative"
                                                   class="required-field-asterisks"
                                            >Les conditions particulières du contrat facultatif</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.particularConditionsForOptionalContract">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="table-of-benefits-facultative"
                                                           @change="addDocument($event, 'particularConditionsForOptionalContract')"
                                                    >
                                                </span>
                                                <a v-if="formData.particularConditionsForOptionalContract"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('particularConditionsForOptionalContract')"
                                                >{{ formData.particularConditionsForOptionalContract.name }}</a>
                                                <a v-if="formData.particularConditionsForOptionalContract"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('particularConditionsForOptionalContract')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.particularConditionsForOptionalContract.validFileSize
                                                                 && !$v.formData.particularConditionsForOptionalContract.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 4MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.particularConditionsForOptionalContract.validMimeType
                                                                 && !$v.formData.particularConditionsForOptionalContract.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <!-- Table of benefits facultative -->

                                        <!-- Copy of information note facultative -->
                                        <div class="contract-input-group"
                                            v-if="formData.isOptionalContractAvailable"
                                        >
                                            <label for="copy-of-information-note-facultative"
                                                   class="required-field-asterisks"
                                            >La notice d'information du contrat facultatif</label>
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.copyOfInformationNoteForOptionalContract">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="copy-of-information-note-facultative"
                                                           @change="addDocument($event, 'copyOfInformationNoteForOptionalContract')"
                                                    >
                                                </span>
                                                <a v-if="formData.copyOfInformationNoteForOptionalContract"
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   @click.prevent="downloadDocument('copyOfInformationNoteForOptionalContract')"
                                                >{{ formData.copyOfInformationNoteForOptionalContract.name }}</a>
                                                <a v-if="formData.copyOfInformationNoteForOptionalContract"
                                                   class="close ml-2"
                                                   href=""
                                                   @click.prevent="deleteDocument('copyOfInformationNoteForOptionalContract')"
                                                >×</a>
                                                <FormError v-if="!$v.formData.copyOfInformationNoteForOptionalContract.validFileSize
                                                                 && !$v.formData.copyOfInformationNoteForOptionalContract.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 4MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.copyOfInformationNoteForOptionalContract.validMimeType
                                                                 && !$v.formData.copyOfInformationNoteForOptionalContract.$dirty"
                                                           error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                        <!-- Copy of information note facultative  -->
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto">
                            <button class="btn btn-lg btn-link btn__primary"
                                    :disabled="saveIsLoading"
                                    @click.prevent="redirectToDueList"
                            >
                                <span>Retour vers la page de liste des DUE</span>
                            </button>
                        </div>
                    </div>

                    <div class="input-group mx-sm-auto">
                        <div class="large-btn__box">
                            <button class="btn btn-success btn-lg btn-link btn__save--large"
                                    :disabled="$v.$invalid || saveIsLoading"
                                    @click.prevent="saveAmendmentDue()"
                            >
                                <span>Enregistrer les modifications</span>
                                <ButtonSpinner :isLoading="saveIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import DueSixthStepManager from '../../../service/manager/due/sixthStepManager';
    import DueDocumentManager from '../../../mixins/dueDocumentManager';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import Header from '../../../components/Header';
    import FormError from '../../../components/FormError';
    import MaskedInput from 'vue-masked-input';
    import { mapActions, mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import { downloadFile } from '@/utils/utils';
    import {
        fileMineTypeConstraint,
        filesizeConstraint,
        validDateConstraint,
        isValidDateYearConstraint
    } from '@/utils/validation';
    import { createAmendmentDue } from '@/service/api/dues.api';
    import { successMessage, messageTexts } from '@/utils/sweet-alert-options';

    export default {
        mixins: [DueDocumentManager, ValidationDelayTouch],
        data() {
            return {
                formData: {
                    insurerName: '',
                    contractNumber: '',
                    productsAndOptionsChosen: '',
                    contractStartDate: '',
                    particularConditions: null,
                    copyOfInformationNote: null,
                    isOptionalContractAvailable: null,
                    optionalContractNumber: '',
                    particularConditionsForOptionalContract: null,
                    copyOfInformationNoteForOptionalContract: null,
                },
                saveIsLoading: false,
                downloadDueIsLoading: false
            };
        },
        computed: {
            ...mapGetters({
                legalInformation: 'legalInformation'
            }),
            dueId() {
                return parseInt(this.$route.params.id);
            }
        },
        async mounted() {
            await this.fetchDueLegalInformation();
        },
        methods: {
            ...mapActions({
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            addDocument(event, documentType) {
                this.formData[documentType] = event.target.files[0];
            },
            deleteDocument(documentName) {
                this.formData[documentName] = null;
            },
            async downloadDocument(documentName) {
                await downloadFile({
                    content: this.formData[documentName]
                });
            },
            async redirectToDueList() {
                await this.$router.push({ name: 'due-list'});
            },
            async saveAmendmentDue() {
                this.saveIsLoading = true;

                const additionalFormData = {
                    dueId: this.dueId
                };

                await createAmendmentDue(
                    await DueSixthStepManager.createSixthOrAmendmentStepUpdateRequest(
                        this.formData,
                        additionalFormData,
                        true
                    )
                );

                this.$swal({ title: messageTexts.createAmendmentDueSuccess, ...successMessage });
                this.saveIsLoading = false;

                setTimeout(() => {
                    this.$router.push({ name: 'due-list'});
                }, 3000);
            },
        },
        validations() {
            let validations = {
                formData: {
                    insurerName: {
                        required
                    },
                    contractNumber: {
                        required
                    },
                    productsAndOptionsChosen: {
                        required
                    },
                    contractStartDate: {
                        required,
                        validDate: validDateConstraint,
                        isValidDateYear: isValidDateYearConstraint,
                    },
                    particularConditions: {
                        required,
                        validFileSize: filesizeConstraint(4000000),
                        validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                    },
                    copyOfInformationNote: {
                        required,
                        validFileSize: filesizeConstraint(4000000),
                        validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                    },
                    isOptionalContractAvailable: {
                        required
                    }
                }
            }

            if (this.formData.isOptionalContractAvailable) {
                validations.formData.optionalContractNumber = {
                    required
                };
                validations.formData.particularConditionsForOptionalContract = {
                    required,
                    validFileSize: filesizeConstraint(4000000),
                    validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                }
                validations.formData.copyOfInformationNoteForOptionalContract = {
                    required,
                    validFileSize: filesizeConstraint(4000000),
                    validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                }
            }

            return validations;
        },
        components: {
            Header,
            Sidebar,
            Footer,
            ButtonSpinner,
            FormError,
            MaskedInput
        }
    }
</script>
